export default __webpack_public_path__ + "static/media/f_wdt_c_4.24187555.mp3";